import React from 'react';
import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import { Phone } from '@mui/icons-material';
import { formatPhoneNumber, validatePhoneNumber, getPhoneDigits, isPhoneComplete } from '../../../utils/inputFormatters';

const PhoneQuestion = ({ 
  question, 
  value = '', 
  onChange, 
  interpolateText, 
  answers, 
  error 
}) => {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    const formatted = formatPhoneNumber(inputValue);
    onChange(formatted);
  };

  const handleKeyDown = (event) => {
    // Only prevent input if we already have 10 digits and it's not a deletion key
    const currentDigits = getPhoneDigits(value);
    if (currentDigits.length >= 10 && ![8, 46].includes(event.keyCode)) {
      event.preventDefault();
    }
  };

  // Custom validation for phone numbers
  const phoneError = error || validatePhoneNumber(value);
  const isComplete = isPhoneComplete(value);

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600 }}>
        {interpolateText(question.text, answers)}
      </Typography>
      
      <TextField
        fullWidth
        type="tel"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={question.placeholder || '(123) 456-7890'}
        variant="outlined"
        size="large"
        error={!!phoneError}
        helperText={phoneError || (isComplete ? '✓ Phone number complete' : 'Enter your 10-digit phone number')}
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Phone sx={{ color: isComplete ? 'success.main' : 'action.active' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '1.1rem',
            padding: '12px 14px',
            '& fieldset': {
              borderColor: isComplete ? 'success.main' : undefined,
            },
            '&:hover fieldset': {
              borderColor: isComplete ? 'success.main' : undefined,
            },
            '&.Mui-focused fieldset': {
              borderColor: isComplete ? 'success.main' : undefined,
            }
          },
          '& .MuiFormHelperText-root': {
            color: isComplete && !phoneError ? 'success.main' : undefined,
            fontWeight: isComplete && !phoneError ? 500 : undefined
          }
        }}
      />
      
      {isComplete && !phoneError && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          We'll use this number to contact you about your cleaning service.
        </Typography>
      )}
    </Box>
  );
};

export default PhoneQuestion;